import {authTexts} from './auth_step_texts'
import {pushFBEvent, pushGTMEvent, pushVKEvent} from '../components/helpers'

function authAnalyticsEvents () {
  // push GTM events
  pushGTMEvent({
    'event': 'FirstStepSubmitted'
  })
  pushGTMEvent({
    'event': 'Auth'
  })
  // FB event when lead is authorised
  pushFBEvent('track', 'Lead', { status: localStorage.getItem('lead_status') })
  // VK event lead
  pushVKEvent('lead')
  if (window.location.hostname === "crezu.kz") {
    let _tmr = window._tmr || (window._tmr = []);
    _tmr.push({id: "3162810", type: "reachGoal", goal: "lead", value: 1});
  }
}

function secondStepPrepareAfterAuth () {
  authAnalyticsEvents()
  let country = $("[name=country]").val()
  let name = ''
  let surname = ''
  if (localStorage.getItem('JWTAutocomplete')) {
    name = JSON.parse(localStorage.getItem('JWTAutocomplete')).name
    surname = JSON.parse(localStorage.getItem('JWTAutocomplete')).surname
  } else if (localStorage.getItem('authAutocomplete')) {
    name = JSON.parse(localStorage.getItem('authAutocomplete')).name
    surname = JSON.parse(localStorage.getItem('authAutocomplete')).surname
  }

  checkAgreements()

  // hide topbar and progressbar
  $('header').addClass('hidden')
  $(".topbar.text-center").addClass("hidden").addClass("reg-v2-auth-margin")
  $(".progress_bar_holder").addClass("hidden")
  $(".order-stepper").addClass("hidden")

  // add "Hello, user" h1
  $(".topbar.text-center").after(`<div class="authHeader"><h1 style="text-align: center; margin: 15px">${authTexts[country]().hello} ${name}</h1><div style="margin: 10px;text-align: center; color:rgba(0,28,56,.47)">${authTexts[country]().fastMoney}</div></div>`)

  // move id_number to first position
  $('[name=id_number]').closest('.ui-form__row').insertBefore($('[name=loan_sum]').closest('.ui-form__row'));
  $('[name=id_number]').closest('.ui-dropdown-field').append(`<div style="font-size: 12px;margin-top: 6px;color: #8794a1;font-weight: 300;line-height: 12px">${authTexts[country]().protect}</div>`)
  if (window.interface_v2) $('[name=id_number]').closest('.ui-form__field').find('.ui-form-field-error-message').css('top', '83px')

  // move loan_purpose to 3d position (after sum)
  $('[name=loan_purpose]').closest('.ui-form__row').insertAfter($('[name=loan_sum]').closest('.ui-form__row'));

  // add CTA button for mobile devices
  $('[name=loan_purpose]').closest('.ui-form__row').after(`<div id="cloneOfSubmit">
    <div class="ui-form__field ui-form__field_component">
      <div class="ui-form__component">
        <div class="app-form-forward-wrap" style="text-align: center">
          <button class="ui-button ui-button_size_xxl app-form-forward-button" type="submit" target=""><span class="ui-button__text">${authTexts[country]().getMoney}</span><i class="ui-button__text" style="width: 23px;height: 23px;margin-left: 10px;display: inline-block;fill: white;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 23px;height: 23px;vertical-align: middle"><path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" data-name="checkmark"></path></svg></i></button>
        </div>
      </div>
    </div>
  </div>`)

  addTopbar(name, surname, country)

  setTimeout(function () {
    $('.personales-divider').insertAfter($('#cloneOfSubmit'))
    // enable slider if it exists
    $('#loan_sum_range').prop('disabled', false)
  }, 500)
}

function addTopbar (name, surname, country) {
  $('.box-wrapper').prepend(`<div class="apl-account-navbar"><div class="apl-account-navbar__container apl-container"><div class="apl-account-navbar__menu"><div class="apl-account-navbar__menu-item"><i class="apl-icon apl-account-navbar__menu-item-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <rect width="24" height="24" opacity="0"></rect>
    <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z"></path>
    <path d="M12 13a7 7 0 0 0-7 7 1 1 0 0 0 2 0 5 5 0 0 1 10 0 1 1 0 0 0 2 0 7 7 0 0 0-7-7z"></path>
    </svg></i><span class="apl-account-navbar__menu-item-text">${name} ${surname}</span></div><a id="logout" class="apl-account-navbar__menu-item apl-account-navbar__menu-item_logout" style="cursor: pointer"><i class="apl-icon apl-account-navbar__menu-item-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0"></rect>
    <path d="M7 6a1 1 0 0 0 0-2H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2H6V6z"></path>
    <path d="M20.82 11.42l-2.82-4a1 1 0 0 0-1.39-.24 1 1 0 0 0-.24 1.4L18.09 11H10a1 1 0 0 0 0 2h8l-1.8 2.4a1 1 0 0 0 .2 1.4 1 1 0 0 0 .6.2 1 1 0 0 0 .8-.4l3-4a1 1 0 0 0 .02-1.18z"></path>
    </svg></i><span class="apl-account-navbar__menu-item-text">${authTexts[country]().logout}</span></a></div></div></div>`)
  setTimeout(function () {
    $('#cloneOfSubmit').find("button").on("click", function () {
      pushGTMEvent({
        'event': 'authCTAButtonClick'
      })
    })

    $('#logout').on('click', function () {
      pushGTMEvent({
        'event': 'logoutButtonClick'
      })
      localStorage.removeItem('JWTAutocomplete', null)
      localStorage.removeItem('auth_token', null)
      localStorage.removeItem('authAutocomplete', null)
      window.onbeforeunload = null;
      if (!is_iframe) {
        window.location.href = '/reg';
      } else {
        document.location.reload()
      }
    })

    $('.apl-account-navbar__menu-item').on('click', function () {
      pushGTMEvent({
        'event': 'accountClick'
      })
    })
  }, 500)
}

function checkAgreements () {
  $('#agreement').prop('checked', true)
  $('#agreement').closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked');
  $('#agreement_2').prop('checked', true)
  $('#agreement_2').closest('.ui-checkbox-directive').find('label').addClass('ui-checkbox_checked');
}

export {secondStepPrepareAfterAuth, addTopbar, checkAgreements, authAnalyticsEvents}
